// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2D0L-","label":"Labeled_label__3tmAM","divider":"Labeled_divider__2HaPo"};